import { GetCheckoutSummaryQuery } from '__generated__/graphql';

/* source-hash: acf355a2c0faf8a6e66f13c6f5684b2a6b20366d */

/* eslint-disable */
const GetCheckoutSummaryResponse = {
    "__typename": "Query",
    "checkoutSummary": {
        "__typename": "PurchasesSummary",
        "amount": 0,
        "vat_amount": 0,
        "passed_on_fee": 0,
        "passed_on_fee_vat_amount": 0,
        "down_payment_amount": 0,
        "down_payment_passed_on_fee": 0,
        "down_payment_passed_on_fee_vat_amount": 0,
        "coupon_status": null,
        "queue": null,
        "time_left": 300,
        "total_time": 300,
        "tickets": [],
        "products": [],
        "coupon_code": null
    },
    "event": {
        "__typename": "Event",
        "id": "TESTRUN",
        "ticket_categories": [
            {
                "__typename": "TicketCategory",
                "id": "TESTTCKCATRUN1",
                "current_max_per_order": 250,
                "tickets_for_sale": [
                    {
                        "__typename": "Ticket",
                        "id": "TESTTCK5KM",
                        "current_max_per_order": 2499,
                        "is_sold_out": false,
                        "upcoming_time_slots": [],
                        "promotions_for_sale": [
                            {
                                "__typename": "Promotion",
                                "id": "TESTPRM5KM1",
                                "current_max_per_order": null,
                                "is_sold_out": false
                            }
                        ]
                    },
                    {
                        "__typename": "Ticket",
                        "id": "TESTTCK10KM",
                        "current_max_per_order": 2499,
                        "is_sold_out": false,
                        "upcoming_time_slots": [],
                        "promotions_for_sale": [
                            {
                                "__typename": "Promotion",
                                "id": "TESTPRM10KM1",
                                "current_max_per_order": null,
                                "is_sold_out": false
                            },
                            {
                                "__typename": "Promotion",
                                "id": "TESTPRM10KM2",
                                "current_max_per_order": null,
                                "is_sold_out": false
                            }
                        ]
                    },
                    {
                        "__typename": "Ticket",
                        "id": "TESTTCK15KM",
                        "current_max_per_order": 1000,
                        "is_sold_out": false,
                        "upcoming_time_slots": [
                            {
                                "__typename": "TimeSlot",
                                "id": "TESTTSL15KM1",
                                "current_max_per_order": 500,
                                "is_sold_out": false
                            },
                            {
                                "__typename": "TimeSlot",
                                "id": "TESTTSL15KM2",
                                "current_max_per_order": 500,
                                "is_sold_out": false
                            }
                        ],
                        "promotions_for_sale": [
                            {
                                "__typename": "Promotion",
                                "id": "TESTPRM15KM1",
                                "current_max_per_order": null,
                                "is_sold_out": false
                            }
                        ]
                    },
                    {
                        "__typename": "Ticket",
                        "id": "TESTTCK20KM",
                        "current_max_per_order": 1000,
                        "is_sold_out": false,
                        "upcoming_time_slots": [
                            {
                                "__typename": "TimeSlot",
                                "id": "TESTTSL20KM1",
                                "current_max_per_order": 500,
                                "is_sold_out": false
                            },
                            {
                                "__typename": "TimeSlot",
                                "id": "TESTTSL20KM2",
                                "current_max_per_order": 500,
                                "is_sold_out": false
                            }
                        ],
                        "promotions_for_sale": [
                            {
                                "__typename": "Promotion",
                                "id": "TESTPRM20KM1",
                                "current_max_per_order": null,
                                "is_sold_out": false
                            },
                            {
                                "__typename": "Promotion",
                                "id": "TESTPRM20KM2",
                                "current_max_per_order": null,
                                "is_sold_out": false
                            }
                        ]
                    }
                ]
            },
            {
                "__typename": "TicketCategory",
                "id": "TESTTCKCATRUN2",
                "current_max_per_order": 250,
                "tickets_for_sale": [
                    {
                        "__typename": "Ticket",
                        "id": "TESTTCKFRIENDS",
                        "current_max_per_order": 92,
                        "is_sold_out": false,
                        "upcoming_time_slots": [],
                        "promotions_for_sale": [
                            {
                                "__typename": "Promotion",
                                "id": "TESTPRMFRIENDS1",
                                "current_max_per_order": null,
                                "is_sold_out": false
                            }
                        ]
                    }
                ]
            },
            {
                "__typename": "TicketCategory",
                "id": "TESTTCKCATRUN3",
                "current_max_per_order": 250,
                "tickets_for_sale": [
                    {
                        "__typename": "Ticket",
                        "id": "TESTTCKBUSINESS",
                        "current_max_per_order": null,
                        "is_sold_out": false,
                        "upcoming_time_slots": [],
                        "promotions_for_sale": [
                            {
                                "__typename": "Promotion",
                                "id": "TESTPRMBUSINESS1",
                                "current_max_per_order": null,
                                "is_sold_out": false
                            }
                        ]
                    }
                ]
            }
        ],
        "products_for_sale": [
            {
                "__typename": "Product",
                "id": "TESTPRDMEDAL",
                "current_max_per_order": null,
                "is_sold_out": false,
                "promotions_for_sale": [
                    {
                        "__typename": "Promotion",
                        "id": "TESTPRMMEDAL1",
                        "current_max_per_order": null,
                        "is_sold_out": false
                    }
                ],
                "active_product_variants": []
            },
            {
                "__typename": "Product",
                "id": "TESTPRDTSHIRT",
                "current_max_per_order": 1694,
                "is_sold_out": false,
                "promotions_for_sale": [
                    {
                        "__typename": "Promotion",
                        "id": "TESTPRMTSHIRT1",
                        "current_max_per_order": null,
                        "is_sold_out": false
                    }
                ],
                "active_product_variants": [
                    {
                        "__typename": "ProductVariant",
                        "id": "TESTPVTSHIRT1",
                        "current_max_per_order": 499,
                        "is_sold_out": false
                    },
                    {
                        "__typename": "ProductVariant",
                        "id": "TESTPVTSHIRT2",
                        "current_max_per_order": 699,
                        "is_sold_out": false
                    },
                    {
                        "__typename": "ProductVariant",
                        "id": "TESTPVTSHIRT3",
                        "current_max_per_order": 500,
                        "is_sold_out": false
                    }
                ]
            },
            {
                "__typename": "Product",
                "id": "TESTPRDAFTERPARTY",
                "current_max_per_order": null,
                "is_sold_out": false,
                "promotions_for_sale": [
                    {
                        "__typename": "Promotion",
                        "id": "TESTPRMAFTERPARTY1",
                        "current_max_per_order": null,
                        "is_sold_out": false
                    },
                    {
                        "__typename": "Promotion",
                        "id": "TESTPRMAFTERPARTY2",
                        "current_max_per_order": null,
                        "is_sold_out": false
                    },
                    {
                        "__typename": "Promotion",
                        "id": "TESTPRMAFTERPARTY3",
                        "current_max_per_order": null,
                        "is_sold_out": false
                    }
                ],
                "active_product_variants": [
                    {
                        "__typename": "ProductVariant",
                        "id": "TESTPVAFTERPARTY1",
                        "current_max_per_order": null,
                        "is_sold_out": false
                    },
                    {
                        "__typename": "ProductVariant",
                        "id": "TESTPVAFTERPARTY2",
                        "current_max_per_order": null,
                        "is_sold_out": false
                    }
                ]
            },
            {
                "__typename": "Product",
                "id": "TESTPRDRUNNINGMEMBERSHIP",
                "current_max_per_order": null,
                "is_sold_out": false,
                "promotions_for_sale": [
                    {
                        "__typename": "Promotion",
                        "id": "TESTPRMRUNNINGMEMBERSHIP1",
                        "current_max_per_order": null,
                        "is_sold_out": false
                    },
                    {
                        "__typename": "Promotion",
                        "id": "TESTPRMRUNNINGMEMBERSHIP2",
                        "current_max_per_order": null,
                        "is_sold_out": false
                    }
                ],
                "active_product_variants": []
            },
            {
                "__typename": "Product",
                "id": "TESTPRDTIMINGCHIP",
                "current_max_per_order": null,
                "is_sold_out": false,
                "promotions_for_sale": [
                    {
                        "__typename": "Promotion",
                        "id": "TESTPRMTIMINGCHIP1",
                        "current_max_per_order": null,
                        "is_sold_out": false
                    },
                    {
                        "__typename": "Promotion",
                        "id": "TESTPRMTIMINGCHIP2",
                        "current_max_per_order": null,
                        "is_sold_out": false
                    }
                ],
                "active_product_variants": []
            },
            {
                "__typename": "Product",
                "id": "TESTPRDCHARITYDONATION",
                "current_max_per_order": null,
                "is_sold_out": false,
                "promotions_for_sale": [
                    {
                        "__typename": "Promotion",
                        "id": "TESTPRMCHARITYDONATION1",
                        "current_max_per_order": null,
                        "is_sold_out": false
                    },
                    {
                        "__typename": "Promotion",
                        "id": "TESTPRMCHARITYDONATION2",
                        "current_max_per_order": null,
                        "is_sold_out": false
                    },
                    {
                        "__typename": "Promotion",
                        "id": "TESTPRMCHARITYDONATION3",
                        "current_max_per_order": null,
                        "is_sold_out": false
                    }
                ],
                "active_product_variants": []
            },
            {
                "__typename": "Product",
                "id": "TESTPRDSPONSORSHIPPACKAGE",
                "current_max_per_order": 1,
                "is_sold_out": false,
                "promotions_for_sale": [
                    {
                        "__typename": "Promotion",
                        "id": "TESTPRMSPONSORSHIPPACKAGE1",
                        "current_max_per_order": null,
                        "is_sold_out": false
                    },
                    {
                        "__typename": "Promotion",
                        "id": "TESTPRMSPONSORSHIPPACKAGE2",
                        "current_max_per_order": null,
                        "is_sold_out": false
                    }
                ],
                "active_product_variants": []
            }
        ]
    }
} as GetCheckoutSummaryQuery;

export default GetCheckoutSummaryResponse;
